import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  actionsBar: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },
  seasonPriceContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  dialogTitle: {
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  activityModal: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '800px',
    }
  },
  modalContent: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
  },
  modalText: {
    color: theme.palette.tertiary.main,
    fontSize: 24,
    fontStyle: 'italic',
    fontWeight: '300',
  },
}));
